export default __webpack_public_path__ + "static/media/down.79f71b6f.svg";